
 import archivopolizaReducer from './archivopolizaReducer';

 export default {archivopolizaReducer}